// SHARED
export const BEFORE_SHARED = 'BEFORE_SHARED'

// FAQ
export const BEFORE_FAQ = 'BEFORE_FAQ'
export const GET_FAQ_LIST = 'GET_FAQ_LIST'
